import React from "react";

export function DanishTaC() {
    return <div className="container terms-and-conditions">
        <h1>Vilkår og Betingelser</h1>
        <p><strong>Sidst opdateret:</strong> 10. oktober 2025</p>

        <p>Læs venligst disse vilkår og betingelser ("<strong>Vilkår</strong>") grundigt, før du bruger
            Sælv‑applikationen ("<strong>Tjenesten</strong>"), som drives af <strong>Sælv
                (Enkeltmandsvirksomhed)</strong>, Otto Brandenburgs Gade 16, 8000 Aarhus C, Danmark
            ("<strong>Sælv</strong>", "vi", "os" eller "vores"). Ved at bruge Tjenesten accepterer du disse
            Vilkår. Hvis du ikke accepterer dem, må du ikke bruge Tjenesten.</p>

        <h2>1. Udbyder (tjenesteudbyderoplysninger)</h2>
        <ul>
            <li>Sælv (Enkeltmandsvirksomhed)</li>
            <li>CVR-nr.: 45234576</li>
            <li>Adresse: Otto Brandenburgs Gade 16, 8000 Aarhus C, Danmark</li>
            <li>E-mail (brugere): <a href="mailto:kontakt@saelv.dk">kontakt@saelv.dk</a></li>
            <li>DSA single point of contact (myndigheder/brugere): <a
                href="mailto:kontakt@saelv.dk">kontakt@saelv.dk</a> (dansk/engelsk)
            </li>
        </ul>

        <h2>2. Tjenestens art og anvendelsesområde</h2>
        <p>Tjenesten gør det muligt for brugere at <strong>tilføje og finde gårdbutikker, vejboder,
            tillidsstativer og andet genbrug/hjemmedyrket materiale</strong> på et kort. Indhold er som
            udgangspunkt synligt for offentligheden. Tjenesten kan bruges i <strong>Danmark</strong>.</p>

        <h2>3. Konto og aldersforhold</h2>
        <p>Du kan bruge Tjenesten uden konto. For konti skal du give korrekte og opdaterede oplysninger (fx navn
            og e‑mail). Adgangskoder må ikke deles. Mistanke om misbrug meddeles straks til os. Vi kan
            suspendere eller lukke konti ved brud på Vilkår eller sikkerhedsrisici.</p>

        <h2>4. Licens</h2>
        <p>Du får en personlig, ikke-eksklusiv, ikke-overdragelig og tilbagekaldelig licens til at installere og
            bruge Tjenesten i overensstemmelse med disse Vilkår.</p>

        <h2>5. Brugerindhold (UGC)</h2>
        <ul>
            <li><strong>Ejerskab:</strong> Du bevarer rettighederne til dit tekst‑ og kortindhold, du indsender
                til Tjenesten.
            </li>
            <li><strong>Licens til os:</strong> Du giver os en global, ikke‑eksklusiv, royaltyfri licens (med
                ret til underlicens til drift/hosting‑partnere) til at lagre, hoste, kopiere, transmittere og
                vise indhold med det ene formål at levere Tjenesten. Licensen ophører, når indholdet eller din
                konto slettes, undtagen i det omfang vi af drifts- eller sikkerhedshensyn midlertidigt skal
                bevare log‑ eller backupkopier samt i lovpligtige perioder.
            </li>
            <li><strong>Garantier:</strong> Du indestår for, at du har de nødvendige rettigheder, og at indhold
                ikke er ulovligt, krænkende, vildledende, skadevoldende, injurierende, diskriminerende, eller
                indeholder uautoriserede personoplysninger/malware.
            </li>
            <li><strong>Moderation (manuel):</strong> For at beskytte kvaliteten godkender vi alle nye steder
                (boder m.v.) og ændringer på crowd‑sourcet indhold uden identificerbar ejer. Vi kan fjerne eller
                deaktivere indhold ved formodet brud på lov eller Vilkår.
            </li>
            <li><strong>Anmeldelse af indhold (notice &amp; action):</strong> Indhold kan <strong>anmeldes
                direkte i appen</strong> fra det pågældende indhold. Du bedes angive en beskrivelse samt
                kontaktoplysninger hvis du ikke er logget ind. Vi vurderer og handler uden unødigt ophold og
                giver besked om afgørelsen.
            </li>
        </ul>

        <h2>6. DSA‑relaterede oplysninger</h2>
        <p><strong>6.1. Offentlig udbredelse:</strong> Indhold i Tjenesten gøres tilgængeligt for
            offentligheden, og Sælv fungerer derfor som en hostingtjeneste/online platform. Vi udøver
            indholdsmoderation som beskrevet i afsnit 5 og 23.</p>
        <p><strong>6.2. Statement of reasons:</strong> Hvis vi fjerner eller begrænser indhold/adgang, sender vi
            en kortfattet, begrundet afgørelse til den berørte bruger (og ejeren, hvis relevant) med oplysninger
            om klagemuligheder.</p>
        <p><strong>6.3. Intern klageordning:</strong> Du kan <strong>gratis</strong> klage over
            moderationsbeslutninger i op til <strong>6 måneder</strong> fra afgørelsen via <a
                href="mailto:kontakt@saelv.dk">kontakt@saelv.dk</a>. Vi behandler klager rettidigt og under
            kvalificeret medarbejdertilsyn. Uafhængig tvistbilæggelse kan anvendes, hvis/når relevant.</p>
        <p><strong>6.4. Kontaktpunkt:</strong> Vores <em>single point of contact</em> for brugere og myndigheder
            er <a href="mailto:kontakt@saelv.dk">kontakt@saelv.dk</a> (dansk/engelsk).</p>
        <p><strong>6.5. Anbefalings‑/rangordningsparametre:</strong> Indhold, der vises for dig, bestemmes
            primært af <strong>afstand i forhold til din placering</strong> (radius‑filtrering). Du kan påvirke
            visningen ved at ændre dine placeringsindstillinger/rettigheder i enheden og den radius Tjenesten
            anvender. Der anvendes ingen profileret annoncering.</p>

        <h2>7. Forbudt adfærd</h2>
        <p>Forbudt: omgåelse af sikkerhed, reverse engineering (ud over ufravigelig ret), automatiseret
            scraping, upload af malware, chikane, hadefuldt/diskriminerende indhold, krænkelse af andres
            rettigheder, og forsøg på uautoriseret adgang.</p>

        <h2>8. Donationer (In‑App Purchases)</h2>
        <p>Du kan frivilligt give <strong>engangsdonationer</strong> til støtte for driften. Donationer
            gennemføres i DKK eller de <strong>valutaer Apple understøtter</strong>. Beløb og eventuel moms
            vises i købsflowet. <strong>Betaling, kvittering og forbrugerhenvendelser om betalinger håndteres af
                Apple</strong>. Sælv tilbyder <strong>ingen refusion</strong>, medmindre præceptiv lov kræver
            det.</p>
        <p>Donationer giver ingen modydelse eller særrettigheder. Tjenesten leverer ikke en digital vare eller
            ydelse som led i donationen.</p>

        <h2>9. Tredjepartstjenester og kortdata</h2>
        <p>Tjenesten benytter korttjenester fra <strong>Apple Maps (iOS)</strong> og <strong>Google Maps
            (Android)</strong>. Brug af disse tjenester er underlagt udbydernes egne vilkår og
            privatlivspolitikker. Lokationsdata og kortvisninger kan være upræcise. Respektér privat ejendom og
            lokale regler ved besøg af viste boder/steder. Sælv er ikke part i eventuelle køb mellem dig og en
            bod/forhandler.</p>

        <h2>10. Immaterielle rettigheder</h2>
        <p>Kode, struktur, design, databaser, logoer og kendetegn tilhører Sælv eller licensgivere. Ingen
            rettigheder overdrages ud over punkt 4. Vores indhold må ikke kopieres eller udnyttes
            (inkl. <strong>scraping/tekst‑ og datamining</strong>) ud over, hvad ufravigelig lov tillader.</p>

        <h2>11. Feedback</h2>
        <p>Forslag/ideer kan frit anvendes af os uden kompensation.</p>

        <h2>12. Databeskyttelse</h2>
        <p>Læs vores <a href="https://saelv.dk/privatlivspolitik">Privatlivspolitik</a> for oplysninger om
            behandling af personoplysninger, herunder kontodata (bruger‑id, navn, e‑mail og push‑tokens). Data
            hostes i EU. Du kan slette din konto og data som beskrevet i punkt 17.</p>

        <h2>13. Sikkerhed</h2>
        <p>Vi anvender passende tekniske og organisatoriske foranstaltninger (fx HTTPS og adgangskontrol for
            privat indhold), men fuld sikkerhed kan ikke garanteres. Brug sker på eget ansvar.</p>

        <h2>14. Systemkrav, kompatibilitet og opdateringer</h2>
        <ul>
            <li><strong>iOS:</strong> iOS 17 eller nyere.</li>
            <li><strong>Android:</strong> Android 10 (API 29) eller nyere.</li>
            <li><strong>Opdateringer:</strong> Vi tilbyder funktionelle og sikkerhedsmæssige opdateringer, så
                længe appen er tilgængelig i de respektive app stores.
            </li>
        </ul>

        <h2>15. Ansvarsbegrænsning</h2>
        <p>I det omfang loven tillader det gælder følgende: (a) Vi er ikke ansvarlige for indirekte
            tab/følgeskader, driftstab, datatab eller tabt goodwill; (b) Vores samlede ansvar pr.
            12‑månedersperiode er begrænset til <strong>1.000 DKK</strong> eller summen af dine donationer i
            perioden (det højeste beløb); (c) Intet i disse Vilkår begrænser ansvar for forsæt/grov uagtsomhed,
            personskade/død forårsaget af uagtsomhed, produktansvar, databeskyttelsesovertrædelser hvor
            fraskrivelse ikke er tilladt, eller andre ufravigelige rettigheder.</p>

        <h2>16. Garantifraskrivelse</h2>
        <p>Tjenesten leveres "som den er" og "som tilgængelig" uden udtrykte eller underforståede garantier
            (herunder salgbarhed, egnethed, ikke‑krænkelse og tilgængelighed) i det omfang loven tillader.</p>

        <h2>17. Opsigelse, sletning og opbevaring</h2>
        <p>Du kan til enhver tid stoppe brugen eller <strong>anmode om sletning i appen</strong>. Sletning
            effektueres <strong>øjeblikkeligt</strong> i aktive systemer. Eventuelle tekniske midlertidige
            kopier i caches/backups overskrives løbende efter vores normale driftscyklusser. Nødvendige data kan
            opbevares i lovpligtige perioder (fx bogføring, sikkerhed, retskrav).</p>
        <p>Vi kan suspendere eller lukke konti ved væsentligt/gentaget brud på Vilkår, ved lovkrav eller
            sikkerhedsrisiko. Gentagne overtrædelser kan medføre udelukkelse fra platformen.</p>

        <h2>18. Ændringer af Vilkår</h2>
        <p>Væsentlige ændringer varsles mindst <strong>30 dage</strong> før ikrafttræden via in‑app meddelelse
            og/eller e‑mail (hvis oplyst) og evt. push‑besked. <strong>Fortsat brug efter
                ikrafttræden</strong> udgør accept.
        </p>

        <h2>19. Apple‑ og Google‑platformskrav</h2>
        <p><strong>iOS:</strong> Brug af iOS‑appen er underlagt <strong>Apple’s Standard EULA</strong>. Apple og
            Apples datterselskaber er tredjeparts‑begunstigede af disse Vilkår og kan håndhæve dem over for dig.
            Support og vedligehold ydes af Sælv, ikke af Apple.</p>
        <p><strong>Google Play (Android):</strong> Ingen særlige vilkår ud over disse Vilkår. Support og
            vedligehold ydes af Sælv.</p>

        <h2>20. Klagemuligheder</h2>
        <p>Kan en tvist ikke løses direkte, kan forbrugere i Danmark klage via <strong>Nævnenes Hus – Center for
            Klageløsning</strong>, Toldboden 2, 8800 Viborg, telefon +45 72 40 56 00, eller
            via <strong>Klageportalen</strong> på Nævnenes Hus’ hjemmeside. Regler om adgang og beløbsgrænser
            fremgår af Nævnenes Hus.</p>

        <h2>21. Lovvalg og værneting</h2>
        <p>Disse Vilkår er underlagt <strong>dansk ret</strong> (uden henvisningsregler). Tvister kan anlægges
            ved de danske domstole med værneting i <strong>København</strong>, medmindre ufravigelig
            forbrugerbeskyttelse i dit bopælsland foreskriver andet.</p>

        <h2>22. Force majeure</h2>
        <p>Vi er ikke ansvarlige for forhold uden for rimelig kontrol (fx strømudfald, netfejl, myndighedspåbud,
            cyberangreb, naturbegivenheder).</p>

        <h2>23. Ugyldighed</h2>
        <p>Er en bestemmelse ugyldig, påvirker det ikke de øvrige; den erstattes af en gyldig bestemmelse med
            tilsvarende formål.</p>

        <h2>24. Sprog</h2>
        <p>Vilkårene foreligger på dansk og engelsk. Ved uoverensstemmelser er <strong>dansk version
            styrende</strong>.</p>

        <h2>25. Kontakt</h2>
        <p>Spørgsmål: <a href="mailto:kontakt@saelv.dk">kontakt@saelv.dk</a></p>
    </div>;
}